const DEMO_MODE_ACTION_TYPES = {
    CLOSE_DEMO: 'CLOSE_DEMO',
    LAUNCH_DEMO: 'LAUNCH_DEMO',
    RESET_TOUR: 'RESET_TOUR',
    SET_HAS_DEMO_TYPE_TRANSITION_ENDED: 'SET_HAS_DEMO_TYPE_TRANSITION_ENDED',
    SET_ACTIVE_TOUR_STEP_ID: 'SET_ACTIVE_TOUR_STEP_ID',
    SET_DEMO_TYPE: 'SET_DEMO_TYPE',
    SET_DEMO_CLASS: 'SET_DEMO_CLASS',
    CANCEL_TOUR: 'CANCEL_TOUR',
    LOAD_DEMO_DATA: 'LOAD_DEMO_DATA',
    LOAD_DEMO_ERROR: 'LOAD_DEMO_ERROR',
};

export default DEMO_MODE_ACTION_TYPES;
